<template>
    <div class="login-page">
        <LoginForm />
    </div>
</template>

<script lang="ts" setup>
    import LoginForm from '@/components/Login/LoginForm.vue'
</script>
